import { Injectable, inject } from "@angular/core";
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { MitpManagerService } from "./mitp-manager.service";
import { AuthService } from "./auth.service";
import { NotificationService } from "./notification.service";
import { HttpLoadingService } from "./http-loading.service";
import { SKIP_ERROR_TOAST, SKIP_LOADING } from "./http-context-tokens";

@Injectable({
	providedIn: "root",
})
export class HttpInterceptorService implements HttpInterceptor {
	mitpManager = inject(MitpManagerService);
	private authService = inject(AuthService);
	private toastr = inject(NotificationService);
	private httpLoading = inject(HttpLoadingService);

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (this.authService.logoutIfSessionExpired()) {
			this.mitpManager.showLoading(false);
			this.mitpManager.openErrorDialog("Votre session a expiré ! Merci de vous reconnecter.");
			return throwError(
				() =>
					new HttpErrorResponse({
						status: 401,
						statusText: "Expired JWT Token",
						error: { message: "Expired JWT Token" },
					})
			);
		}
		const handled = next
			.handle(req)
			.pipe(catchError((error) => this.handleError(error, req.context.get(SKIP_ERROR_TOAST))));
		if (req.context.get(SKIP_LOADING)) {
			return handled;
		}
		this.httpLoading.start();
		return handled.pipe(finalize(() => this.httpLoading.stop()));
	}

	handleError(error: HttpErrorResponse, skipToast = false) {
		this.mitpManager.showLoading(false);
		if (error.status == 401) {
			this.authService.logoutIfSessionExpired();
		}
		if (error.error.message != undefined) {
			switch (error.error.message) {
				case "Expired JWT Token":
					this.mitpManager.openErrorDialog("Votre session a expiré ! Merci de vous reconnecter.");
					break;
				case "Invalid credentials.":
					this.mitpManager.openErrorDialog("Indentifiants incorrects !");
					break;
				default:
					if (this.authService.isAuth() && !skipToast) {
						this.toastr.error(error.error.message);
					}
			}
		}
		this.mitpManager.showLoading(false);
		return throwError(() => error);
	}
}
